import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  aStyle: {
    textDecorationLine: "none",
    cursor: "pointer",
    [theme.breakpoints.up("md")]: {
      width: "345px",
    },
  },
  baseRoot: {
    position: "relative",
    width: "100%",
    [theme.breakpoints.down("md")]: {
      marginBottom: "22px",
    },
  },
  root: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    overflow: "hidden",
    boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px;",
    borderRadius: "18px",
    position: "relative",
  },
  monthPrice: {},
  mainPrice: {},
  figmaPriceAmount: {},
  figmaPriceSuffix: {},
  monthText: {},
  oldPrice: {},
  itemInner: {
    width: "100%",
    border: "8px solid #3b51fc",
    borderTop: "none",
    background: "#3b51fc",
  },
  moreHeight: {
    minHeight: "248px !important",
  },
  whiteContent: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    borderRadius: "12px",
    padding: "12px 24px 24px 24px",
    background: "#fff",
    [theme.breakpoints.down("md")]: {
      padding: "12px 14px 24px 14px",
      minHeight: "194px",
    },
    "& $monthPrice": {
      fontWeight: 800,
      fontSize: "20px",
      color: "#000",
      textAlign: "center",
      [theme.breakpoints.down("md")]: {
        fontSize: "20px",
      },
    },
    "& $mainPrice": {
      fontWeight: 700,
      fontSize: "18px",
      color: "#3b51fc",
      marginTop: "6px",
      marginBottom: "6px",
      display: "block",
      textAlign: "center",
    },
    "& $oldPrice": {
      fontSize: "22px",
      color: "#e25959",
      fontWeight: "800",
      textDecorationLine: "line-through",
      display: "block",
      textAlign: "center",
      [theme.breakpoints.down("md")]: {
        fontSize: "18px",
      },
      "& > #slash-text": {
        color: "#E05D48",
        textDecoration: "line-through",
        fontWeight: "800",
      },
    },
    [theme.breakpoints.up("md")]: {
      minHeight: "212px",
    },
  },
  bottomInner: {
    padding: "18px 0",
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    bottom: 0,
    backgroundColor: "#3b51fc",
    "& > span": {
      color: "#fff",
      fontWeight: "900",
      fontSize: "16px",
      textTransform: "uppercase",
      textAlign: "center",
    },
    "&  #activeText": {
      // color: "#FDC12C",
      marginLeft: 6,
    },
    [theme.breakpoints.down("md")]: {
      padding: "16px 0",
    },
    [theme.breakpoints.up("md")]: {
      height: 54,
    },
  },
  btnAbsolute: {
    width: "100%",
    marginTop: "16px",
    bottom: 24,
    position: "absolute",
  },
  btnStyle: {
    margin: "auto",
    minWidth: "110px",
    paddingLeft: "32px",
    paddingRight: "32px",
    width: "auto",
    height: "48px",
    boxShadow: "gba(0, 0, 0, 0.35) 0px 5px 15px;",
    "& > span": {
      fontWeight: "800 !important",
      color: "#000 !important",
      fontSize: "14px !important",
      textTransform: "none",
    },
    [theme.breakpoints.up("sm")]: {
      height: "42px",
    },
    [theme.breakpoints.down("md")]: {
      paddingLeft: "24px",
      paddingRight: "24px",
      height: "44px",
      "& > span": {
        fontSize: "16px !important",
      },
    },
  },
  blackText: {
    color: "#000 !important",
    textDecorationLine: "none !important",
    fontSize: "22px",
    marginTop: "6px",
    "& > span:last-child": {
      // color: "#000",
      fontWeight: "900",
      [theme.breakpoints.up("sm")]: {
        fontSize: "30px !important",
      },
    },
  },
  ovrBlackText: {
    color: "#000 !important",
    textDecorationLine: "none !important",
    fontSize: "22px",
    marginTop: "6px",
    "& > span:last-child": {
      color: "#000",
      fontWeight: "700",
    },
  },
  ctnPromo: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "#afefb5",
    padding: "8px 12px",
    borderRadius: 12,
    marginTop: 6,
    marginBottom: 2,
    "& > span": {
      color: "#419F61",
      fontWeight: 800,
      marginLeft: 6,
    },
    "& > #ctn-check": {
      marginTop: 4,
      "& img": {
        width: 18,
        height: 18,
        objectFit: "contain",
      },
    },
  },
  txtIntro: {
    fontWeight: "800",
    color: "#00A551 !important",
    fontSize: "18px",
    marginBottom: -4,
    [theme.breakpoints.down("xs")]: {
      fontSize: "16px !important",
    },
  },
}));
